import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
  Autoplay,
  Controller,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  EffectFade,
} from "swiper/core";
import { useCallback } from "react";

SwiperCore.use([
  Autoplay,
  Controller,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  EffectFade,
]);

function SliderCore({ onSwiper, ...props }) {
  const { children, sliderOptions = {} } = props;
  // 複数行にする場合はslidesPerColumnを指定する
  const handleSwiper = useCallback(
    (control) => {
      if (onSwiper) {
        onSwiper(control);
      }
    },
    [onSwiper]
  );

  return (
    <Swiper {...sliderOptions} onSwiper={handleSwiper}>
      {React.Children.map(children, (item, i) => (
        <SwiperSlide key={`swiper-slide-${i}`}>{item}</SwiperSlide>
      ))}
    </Swiper>
  );
}

export default SliderCore;
